import classNames from 'classnames'

import { ButtonRoundSm, ControlledInputDebounced, SelectInputSM } from '@apps-common/components/elements'
import { ModalBody, ModalHeader, ModalHeaderContainer } from '@apps-common/components/modals/modal'
import { commonIcons } from '@apps-common/config/icons'
import { INPUT_CLASSES, INPUT_CONTAINER_CLASSES } from '@apps-common/config/input-styles'
import { ModalDismiss } from '@apps-common/config/modal'
import { UNIT_ACTIVATION_STATUS_VALUES } from '@apps-common/config/unit-activation'
import { useUnitActivationFilter } from '@apps-common/stores'
import { FilterModalContainer } from './filter/FilterModalContainer'

export const UnitActivationsFilterModal = ({
  onDismiss
}: {
  onDismiss: (data?: string | null | undefined | number, role?: string) => void
}) => {
  const state = useUnitActivationFilter()

  return (
    <FilterModalContainer onDismiss={onDismiss}>
      <ModalHeaderContainer>
        <div className='flex items-start justify-between'>
          <ModalHeader subtitle='Device Activations' title='Filter' subtitleClasses='capitalize' />
          <div className='flex items-center gap-[10px]'>
            <ButtonRoundSm
              type='button'
              className='action-brand'
              disabled={state.isFiltered()}
              callback={() => {
                state.clear()
                onDismiss(null, ModalDismiss.Confirm)
              }}
            >
              <commonIcons.reload />
            </ButtonRoundSm>
            <ButtonRoundSm
              type='button'
              className='action-brand-solid'
              callback={() => {
                onDismiss(null, ModalDismiss.Confirm)
              }}
            >
              <commonIcons.close />
            </ButtonRoundSm>
          </div>
        </div>
      </ModalHeaderContainer>
      <ModalBody classes='relative !pt-[100px] !pb-[30px] sm:!pb-[20px]'>
        <div className='grid gap-[10px]'>
          {/* STATUS */}
          <SelectInputSM
            placeholder='All Statuses'
            label='Status'
            showLabel
            id='device-activation-filter-status'
            className={INPUT_CLASSES}
            containerClassName={INPUT_CONTAINER_CLASSES}
            options={UNIT_ACTIVATION_STATUS_VALUES}
            hideError
            registration={{ value: state.statusVal, onChange: (e: any) => state.setStatusVal(e?.target?.value || '') }}
          />
          {/* SEARCH */}
          <ControlledInputDebounced
            type='text'
            placeholder='Search device activations...'
            label='Search'
            showLabel
            id='device-activation-filter-search'
            className={INPUT_CLASSES}
            containerClassName={classNames(INPUT_CONTAINER_CLASSES)}
            value={state.searchVal}
            onChange={(e) => state.setSearchVal(e?.target?.value || '')}
          />
        </div>
      </ModalBody>
    </FilterModalContainer>
  )
}
